module.exports = __webpack_public_path__ + "img/fraude_eight.6367650d.png";